import { ReactElement } from 'react'

import { Translation } from 'react-i18next'

import { titleCase } from 'helpers/formatting'
import { DspLineItem } from 'types'

import DetailTag from './shared/DetailTag'
import { DetailText } from './shared/DetailText'
import { DetailWrapper } from './shared/DetailWrapper'

export function lineItemTypeRenderer(lineItem: DspLineItem): ReactElement {
    const text = titleCase(lineItem.line_item_type)
    return (
        <DetailWrapper
            leftContent={<DetailTag text="Line Item Type" />}
            rightContent={<DetailText text={text} />}
        />
    )
}

export function regionalAdvertiserRenderer(): ReactElement {
    return (
        <DetailWrapper
            leftContent={
                <DetailTag
                    type="primary"
                    text={
                        <Translation>
                            {(t) => t('common:regional', 'Regional')}
                        </Translation>
                    }
                />
            }
        />
    )
}
